import { Card, CardActionArea, Radio, Stack, Typography } from '@mui/material';
import { PaymentMethod as PaymentMethodEnum } from '@/data/catalog/offer/interfaces';
import { StyledBox } from '@/packages/courses/pages/checkout/components/styled-box';
import { paymentMethods } from '@/packages/courses/pages/checkout/constants/payment-methods';

interface PaymentMethodProps {
  selectedMethod: string;
  onSelectMethod: (method: PaymentMethodEnum) => void;
}

export const PaymentMethod = ({
  selectedMethod,
  onSelectMethod,
}: PaymentMethodProps) => {
  return (
    <Stack spacing={2}>
      {paymentMethods.map((method) => (
        <Card key={method.id} variant="outlined" sx={{ border: 'none' }}>
          <CardActionArea
            onClick={() => onSelectMethod(method.id)}
            sx={{ px: 2, py: 3 }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Radio
                checked={selectedMethod === method.id}
                value={method.id}
                size="small"
              />
              <StyledBox>{method.icon}</StyledBox>
              <Typography variant="h3" fontWeight="medium">
                {method.label}
              </Typography>
            </Stack>
          </CardActionArea>
        </Card>
      ))}
    </Stack>
  );
};
